import { useQuery } from '@tanstack/react-query';
import { getAllHardwareTypesBySystem } from '../../../api/hardware';

const useHardwareTypeSystem = (systemId?: string, options?: {}) =>
  useQuery(['hardwareTypeBySystem', systemId], getAllHardwareTypesBySystem, {
    ...options,
  });

export default useHardwareTypeSystem;
